import React from "react";

const SECTORS = ["All", "Business", "Finance", "News", "Tech", "Crypto", "Lifestyle"];

/**
 * Single-select pill filter for the outlet grid. "All" is the default.
 * Active tab renders in brand purple (#7200CB) with white text; inactive
 * tabs are neutral outline. Wraps on mobile.
 */
export default function SectorFilterTabs({ active, onChange }) {
  return (
    <div className="flex flex-wrap items-center justify-center gap-2 mb-10">
      {SECTORS.map((sector) => {
        const isActive = sector === active;
        return (
          <button
            key={sector}
            type="button"
            onClick={() => onChange(sector)}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 ${
              isActive
                ? "bg-cobalt text-white shadow-sm"
                : "bg-white border border-border text-steel hover:border-cobalt/40 hover:text-bone"
            }`}
          >
            {sector}
          </button>
        );
      })}
    </div>
  );
}